import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form-latest';
import { DateRenderer } from '@/components/UI/DateRenderers/DateRenderers';

interface TextProps {
  name: string;
  type?: string;
}

const Text: FC<TextProps> = ({ name, type }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value } }) => {
        if (type === 'date') {
          return <DateRenderer value={value} defaultResponse="-" />;
        }
        return <span>{value ?? '-'}</span>;
      }}
    />
  );
};

export default Text;
